import { WeatherLocationFavouriteItem } from '@deckee/api-app-main';
import { callEndpoint } from '../../../../../services/backend';
import { buildAddWeatherLocationFavouritePayload } from './favouriteIdentity';

export const getWeatherLocationFavourites = async (): Promise<
  WeatherLocationFavouriteItem[]
> => {
  const response = await callEndpoint<{
    data: { favourites: WeatherLocationFavouriteItem[] };
  }>(callEndpoint.endpoints.getWeatherLocationFavourites);

  return response?.favourites || [];
};

export const addWeatherLocationFavourite = async (payload: {
  name: string;
  latitude: number;
  longitude: number;
  state?: string | null;
  region?: string | null;
  locationDescription?: string | null;
  markerType?: string | null;
  markerId?: string | null;
  placeId?: string | null;
}) => {
  const body = buildAddWeatherLocationFavouritePayload(payload);

  return callEndpoint<{ data: { id: string } }>(
    callEndpoint.endpoints.addWeatherLocationFavourite,
    body,
  );
};

export const deleteWeatherLocationFavourite = async (id: string) =>
  callEndpoint<{ data: { id: string } }>(
    callEndpoint.endpoints.deleteWeatherLocationFavourite,
    { id },
  );
